export default __webpack_public_path__ + "static/media/nft-5@2x.e7ba41f7.png";